// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { Route } from 'react-router-dom';
import config from '../config';

class GoogleAnalytics extends Component {
  componentDidMount () {
    this.logPageChange(
      this.props.location.pathname,
      this.props.location.search
    );
  }

  componentDidUpdate ({ location: prevLocation }) {
    const { location: { pathname, search } } = this.props;
    const isDifferentPathname = pathname !== prevLocation.pathname;
    const isDifferentSearch = search !== prevLocation.search;

    if (isDifferentPathname || isDifferentSearch) {
      this.logPageChange(pathname, search);
    }
  }

  logPageChange (pathname, search = '') {
    const page = pathname + search;
    const { location } = window;
    // questionnaire pages will be tracked elsewhere
    if (page !== '/' && page !== '/user/questionnaire' && page !== '/pattern-library') {
      ReactGA.set({
        page,
        location: `${location.origin}${page}`,
        ...this.props.options
      });
      ReactGA.pageview(page);
    }
  }

  render () {
    return null;
  }
}

GoogleAnalytics.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }).isRequired,
  options: PropTypes.object
};

const RouteTracker = () => (<Route component={GoogleAnalytics} />);

const init = (options = {}) => {
  const isGAEnabled = !!config.GOOGLE_ANALYTICS_TRACKING_ID;
  if (isGAEnabled) {
    ReactGA.initialize(
      // debug and staging should point to tracking ID for testing property
      config.GOOGLE_ANALYTICS_TRACKING_ID, {
        debug: process.env.NODE_ENV === 'development',
        cookieDomain: 'none',
        ...options
      }
    );
  }

  return isGAEnabled;
};

export default {
  GoogleAnalytics,
  RouteTracker,
  init
};



// WEBPACK FOOTER //
// ./src/utils/google-analytics.js